export default __webpack_public_path__ + "838833e2689ee601ade240d458420f3d.png";